<template>
  <div class="frisbuy-poll">
    <div
      v-if="interaction.caption"
      class="frisbuy-poll__header"
      :style="{ backgroundColor: interaction.backgroundColor }"
    >
      {{ interaction.caption }}
    </div>

    <div class="frisbuy-poll__body">
      <button
        v-for="(question, index) in interaction.polls"
        class="frisbuy-poll__question"
        :class="{
          'frisbuy-poll__question--disabled': isAnswered,
          'frisbuy-poll__question--selected': answerNumber === index,
          'frisbuy-poll__question--waiting':
            isAnswered &&
            !isQuerySuccess &&
            !isAlreadyAnswered &&
            answerNumber === index,
        }"
        :key="index"
        :disabled="isAnswered"
        @click="handleClick(question, index)"
      >
        <div class="frisbuy-poll__question-text">
          <div
            class="frisbuy-poll__question-progress"
            :style="{
              width: `${
                isAnswered && (isQuerySuccess || isAlreadyAnswered)
                  ? Math.round((question.count / countOfVoites) * 100)
                  : 0
              }%`,
            }"
          ></div>
          <span class="frisbuy-poll__question-text-wrapper">
            <span
              v-for="(title, index) of getListOfDividingTextAndEmoji(
                question.title
              )"
              :key="index"
              class="frisbuy-poll__question-text-input"
              :class="{ 'frisbuy-poll__question-text--emoji': title.isEmoji }"
            >
              {{ title.text }}
            </span>
          </span>

          <div
            :style="{ opacity: Number(isShowPercentage) }"
            class="frisbuy-poll__question-percentage"
          >
            {{
              isShowPercentage
                ? Math.round((question.count / countOfVoites) * 100)
                : "?"
            }}%
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    interaction: {
      type: Object,
      require: true,
    },

    isQuerySuccess: {
      type: Boolean,
      require: false,
      default: true,
    },
  },

  emits: ["chooseAnswer"],

  data() {
    return {
      answerNumber: undefined,
      isAlreadyAnswered: false,
    };
  },

  created() {
    this.updateStatus();
  },

  computed: {
    isAnswered() {
      return this.answerNumber !== undefined;
    },

    countOfVoites() {
      let count = 0;

      this.interaction.polls.forEach((vote) => {
        count += vote.count;
      });

      return count;
    },

    isShowPercentage() {
      return this.isAnswered && (this.isQuerySuccess || this.isAlreadyAnswered);
    },
  },

  methods: {
    handleClick(question, index) {
      this.answerNumber = index;

      this.$emit("chooseAnswer", { index: index, ...question });
    },

    checkOnHasEmoji(word) {
      // NOTE: I decided to leave all +- working regexes. Try it if one will be is incorrect

      // const emojiRegex = /([^\u0020-\u1EFF])/gu;
      /*
        NOTE: "№" char was bugged in prev parsing's version
        8470 === charCodeAt "№"
        2116 is hex of 8470
      */
      const emojiRegex = /([^\u0020-\u2116])/gu;

      // NOTE: check this if check above is incorrect;
      // const emojiRegex = /((\p{Emoji}\uFE0F)|(\p{Emoji_Presentation})|([^\u0020-\u1EFF]))/u;
      // if (word.length === 1) {
      //   return emojiRegex.test(word) && word.charCodeAt(0) > 8470; // 8470 === charCodeAt "№"
      // }

      return emojiRegex.test(word);
    },

    getListOfDividingTextAndEmoji(text) {
      const emojiDividerBuffer = [];

      if (this.checkOnHasEmoji(text)) {
        const arrayOfSymbols = text.match(/./gu);
        let symbolsTypeStartIndex = 0;
        let symbolsTypeEndIndex = 1;
        let isEmoji = false;
        let isPrevEmoji = false;

        arrayOfSymbols.forEach((symbol, index) => {
          isEmoji = this.checkOnHasEmoji(symbol);

          if (index === 0) {
            isPrevEmoji = isEmoji;
          }

          if (isPrevEmoji !== isEmoji) {
            if (symbolsTypeStartIndex === symbolsTypeEndIndex) {
              symbolsTypeEndIndex += 1;
            }

            const stringOfCharsEqualsType = arrayOfSymbols
              .slice(symbolsTypeStartIndex, symbolsTypeEndIndex)
              .join("");

            emojiDividerBuffer.push({
              text: stringOfCharsEqualsType,
              isEmoji: isPrevEmoji,
            });

            symbolsTypeStartIndex = index;
          } else {
            symbolsTypeEndIndex = index + 1;
          }

          isPrevEmoji = isEmoji;
        });

        const stringOfRemainingCharsEqualsType = arrayOfSymbols
          .slice(symbolsTypeStartIndex, symbolsTypeEndIndex + 1)
          .join("");

        emojiDividerBuffer.push({
          text: stringOfRemainingCharsEqualsType,
          isEmoji: isEmoji,
        });
      } else {
        emojiDividerBuffer.push({
          text: text,
          isEmoji: false,
        });
      }

      return emojiDividerBuffer;
    },

    updateStatus() {
      this.interaction.polls.forEach((vote, index) => {
        if (vote.isSelected) {
          this.answerNumber = index;
          this.isAlreadyAnswered = true;
        }
      });
    },
  },

  watch: {
    isQuerySuccess(next) {
      if (!next) {
        this.answerNumber = undefined;
        this.isAlreadyAnswered = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$poll-backgroundColor: #fafafa;
$selected-poll-backgroundColor: #f1eff2;

.frisbuy-poll {
  background-color: #fff;
  border-radius: 10px;
  font-family: Roboto;
  width: calc(var(--frisbuy-interaction-width) * 235 * 1px);

  overflow: hidden;

  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .frisbuy-poll__header {
    word-wrap: break-word;
    background-color: #000;
    text-align: center;
    color: #fff;
    font-size: calc(var(--frisbuy-interaction-width) * 15 * 1px);
    font-family: Roboto Condensed;
    line-height: 110%;
    padding: calc(var(--frisbuy-interaction-width) * 12 * 1px);
  }

  .frisbuy-poll__body {
    display: flex;
    flex-direction: column;
    gap: calc(var(--frisbuy-interaction-width) * 12 * 1px);
    padding: calc(var(--frisbuy-interaction-width) * 12 * 1px);

    .frisbuy-poll__question {
      position: relative;

      // height: 27.388402280852702%;
      height: calc(var(--frisbuy-interaction-width) * 36.87 * 1px);

      border: none;
      border-radius: 15px;

      color: #000;
      font-size: calc(var(--frisbuy-interaction-width) * 12 * 1px);
      text-align: left;

      background-color: $poll-backgroundColor;

      overflow: hidden;

      cursor: pointer;

      margin: 0;
      padding: 0;

      &:hover {
        background-color: #dadada;
      }

      &--disabled:hover {
        background-color: $poll-backgroundColor;
      }

      &--selected,
      &--selected:hover {
        background-color: $selected-poll-backgroundColor;
      }

      &--disabled,
      &--selected {
        cursor: not-allowed;
      }

      &--waiting {
        background: linear-gradient(
          115deg,
          #fff,
          #fff,
          aliceblue,
          #dadada,
          aliceblue,
          #fff,
          #fff
        );
        background-size: 200%;
        animation: gradient-animation 0.75s linear infinite;
        background-repeat: no-repeat;

        @keyframes gradient-animation {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      }

      .frisbuy-poll__question-text {
        display: flex;
        justify-content: space-between;
        gap: 4px;

        max-height: 100%;

        font-weight: 500;

        padding: 0 calc(var(--frisbuy-interaction-width) * 10 * 1px);
        // padding: 4.7332%;

        overflow: hidden;

        &--emoji {
          isolation: isolate;
          position: -webkit-sticky;
        }

        & > * {
          margin: auto 0;
        }

        .frisbuy-poll__question-percentage {
          font-family: "Roboto Slab", sans-serif;
          font-size: calc(var(--frisbuy-interaction-width) * 18 * 1px);
          min-width: calc(var(--frisbuy-interaction-width) * 50 * 1px);
          text-align: right;
        }
      }

      .frisbuy-poll__question-text-wrapper {
        $lineCount: 2;
        $lineHeight: 1.2em;

        max-height: calc($lineHeight * $lineCount);
        line-height: $lineHeight;
      }

      .frisbuy-poll__question-text-input {
        word-break: break-word;
      }

      .frisbuy-poll__question-progress {
        position: absolute;
        top: 0;
        left: 0;
        filter: invert(1);
        mix-blend-mode: difference;
        background-color: #000;
        height: 100%;
        width: 0%;
        transition: width 1.5s ease-in-out;
      }
    }
  }
}
</style>
